import { render } from "./_form-recipient.vue?vue&type=template&id=e5c776c0&lang=pug"
import script from "./_form-recipient.vue?vue&type=script&lang=js"
export * from "./_form-recipient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__